import { IconButton } from '@material-ui/core';
import React from 'react';

import { toggleDrawer } from '../actions';
import { usePageDialog } from '../hooks/use-page-dialog';
import { useReduxDispatch } from '../hooks/use-redux';

export const HeaderDrawerButton = () => {
    const { onClose } = usePageDialog();
    const dispatch = useReduxDispatch();

    const handleToggleDrawer = () => {
        dispatch(toggleDrawer());
    };

    const icon = onClose ? (
        <IconButton onClick={onClose}>
            <i className="material-icons">close</i>
        </IconButton>
    ) : (
        <IconButton onClick={handleToggleDrawer}>
            <i className="material-icons">menu</i>
        </IconButton>
    );

    return icon;
};
